import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import {useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import AppSettingsUI from '../view/AppSettingsUI';
import {OrganizationSettings} from '../../../../data/models/Oganization/Organization';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';
import SettingsStore from '../../store/SettingsStore';
import {settingsText} from '../../settingsText';

interface Props {
  settingsStore?: SettingsStore;
}

const AppSettingsContainer = inject('settingsStore')(
  observer(({settingsStore}: Props) => {
    const [organization, setOrganization] = useState<OrganizationSettings>();
    const [hideCourseIcons, setHideCourseIcons] = useState(false);
    const {organizationId} = useParams();

    useEffect(() => {
      if (!organizationId) return;
      settingsStore!.getOrganizationDetails(organizationId).then(loaded => {
        setOrganization(loaded);
        setHideCourseIcons(!!loaded?.hideCourseIconsInApp);
      });
    }, []);

    const onSave = async () => {
      if (!organization) return;
      const success = await settingsStore!.editOrganization({
        ...organization,
        hideCourseIconsInApp: hideCourseIcons,
      });
      if (success) {
        toast.success(settingsText.detailsUpdated, toastConfig);
      }
    };

    return (
      <AppSettingsUI
        hideCourseIcons={hideCourseIcons}
        setHideCourseIcons={setHideCourseIcons}
        onSave={onSave}
        isLoading={settingsStore!.isLoading}
        canSave={
          !!organization &&
          hideCourseIcons !== !!organization.hideCourseIconsInApp
        }
      />
    );
  }),
);

export default AppSettingsContainer;
